var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloatingPost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1533 4.49133L12.9931 6.13089L15.8329 7.77045L8.63281 20.2414C8.51129 20.4519 8.31727 20.6109 8.08702 20.6887L4.06296 22.049C3.89156 22.1069 3.70826 22.0011 3.67273 21.8237L2.83871 17.6586C2.79099 17.4203 2.8317 17.1728 2.95322 16.9623L10.1533 4.49133Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1326 1.06415C12.4088 0.585854 13.0204 0.421978 13.4987 0.69812L17.446 2.97714C17.9243 3.25329 18.0882 3.86488 17.8121 4.34317L16.3774 6.82812L10.6979 3.5491L12.1326 1.06415Z",
    fill: "#7462E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingPost);
export default __webpack_public_path__ + "static/media/floating_post.a28be060a90015b9b028a12473904402.svg";
export { ForwardRef as ReactComponent };